import { render, staticRenderFns } from "./ParametrizacaoAcaoPasso8.vue?vue&type=template&id=0d9922bf&lang=html"
import script from "./ParametrizacaoAcaoPasso8.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoAcaoPasso8.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoAcaoPasso8.vue?vue&type=style&index=0&id=0d9922bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports